import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["onClick"];
var _hoisted_2 = {
  class: "list-item-text"
};
import TUIChatEngine, { TUIStore, StoreName, TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal } from '@tencentcloud/universal-api';
import { ref, watchEffect, computed, onMounted, onUnmounted } from '../../../../adapter-vue';
import Icon from '../../../common/Icon.vue';
import { Toast, TOAST_TYPE } from '../../../common/Toast/index';
import delIcon from '../../../../assets/icon/msg-del.svg';
import copyIcon from '../../../../assets/icon/msg-copy.svg';
import quoteIcon from '../../../../assets/icon/msg-quote.svg';
import revokeIcon from '../../../../assets/icon/msg-revoke.svg';
import forwardIcon from '../../../../assets/icon/msg-forward.svg';
import convertText from '../../../../assets/icon/convertText_zh.svg';
import { enableSampleTaskStatus } from '../../../../utils/enableSampleTaskStatus';
import { copyText } from '../../utils/utils';
import { decodeTextMessage } from '../../utils/emojiList';
import { isPC, isUniFrameWork } from '../../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    messageItem: {
      default: () => ({})
    }
  },
  setup(__props, _ref) {
    var {
      expose: __expose
    } = _ref;
    var props = __props;
    var TYPES = TUIChatEngine.TYPES;
    var actionItems = ref([{
      key: 'open',
      text: TUITranslateService.t('TUIChat.打开'),
      iconUrl: copyIcon,
      renderCondition() {
        var _message$value;
        if (!message.value) return false;
        return isPC && (((_message$value = message.value) === null || _message$value === void 0 ? void 0 : _message$value.type) === TYPES.MSG_FILE || message.value.type === TYPES.MSG_VIDEO || message.value.type === TYPES.MSG_IMAGE);
      },
      clickEvent: openMessage
    }, {
      key: 'copy',
      text: TUITranslateService.t('TUIChat.复制'),
      iconUrl: copyIcon,
      renderCondition() {
        if (!message.value) return false;
        return message.value.type === TYPES.MSG_TEXT;
      },
      clickEvent: copyMessage
    }, {
      key: 'revoke',
      text: TUITranslateService.t('TUIChat.撤回'),
      iconUrl: revokeIcon,
      renderCondition() {
        if (!message.value) return false;
        return message.value.flow === 'out' && message.value.status === 'success';
      },
      clickEvent: revokeMessage
    }, {
      key: 'delete',
      text: TUITranslateService.t('TUIChat.删除'),
      iconUrl: delIcon,
      renderCondition() {
        if (!message.value) return false;
        return message.value.status === 'success';
      },
      clickEvent: deleteMessage
    }, {
      key: 'forward',
      text: TUITranslateService.t('TUIChat.转发'),
      iconUrl: forwardIcon,
      renderCondition() {
        if (!message.value) return false;
        return message.value.status === 'success';
      },
      clickEvent: forwardSingleMessage
    }, {
      key: 'quote',
      text: TUITranslateService.t('TUIChat.引用'),
      iconUrl: quoteIcon,
      renderCondition() {
        if (!message.value) return false;
        var _message = TUIStore.getMessageModel(message.value.ID);
        return message.value.status === 'success' && !_message.getSignalingInfo();
      },
      clickEvent: quoteMessage
    },
    // {
    //   key: 'translate',
    //   text: TUITranslateService.t('TUIChat.翻译'),
    //   visible: false,
    //   iconUrl: translateIcon,
    //   renderCondition () {
    //     if (!message.value) return false
    //     return message.value.status === 'success' && message.value.type === TYPES.MSG_TEXT
    //   },
    //   clickEvent: translateMessage
    // },
    {
      key: 'convert',
      text: TUITranslateService.t('TUIChat.转文字'),
      visible: false,
      iconUrl: convertText,
      renderCondition() {
        if (!message.value) return false;
        return message.value.status === 'success' && message.value.type === TYPES.MSG_AUDIO;
      },
      clickEvent: convertVoiceToText
    }]);
    var message = ref();
    var messageToolDom = ref();
    onMounted(() => {
      TUIStore.watch(StoreName.CHAT, {
        translateTextInfo: onMessageTranslationInfoUpdated,
        voiceToTextInfo: onMessageConvertInfoUpdated
      });
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CHAT, {
        translateTextInfo: onMessageTranslationInfoUpdated,
        voiceToTextInfo: onMessageConvertInfoUpdated
      });
    });
    watchEffect(() => {
      message.value = TUIStore.getMessageModel(props.messageItem.ID);
    });
    var isAllActionItemInvalid = computed(() => {
      for (var i = 0; i < actionItems.value.length; ++i) {
        if (actionItems.value[i].renderCondition()) {
          return false;
        }
      }
      return true;
    });
    function getFunction(index) {
      // 兼容 vue2 小程序的写法 不允许动态绑定
      actionItems.value[index].clickEvent();
    }
    function openMessage() {
      var _message$value2, _window;
      var url = '';
      switch ((_message$value2 = message.value) === null || _message$value2 === void 0 ? void 0 : _message$value2.type) {
        case TUIChatEngine.TYPES.MSG_FILE:
          url = message.value.payload.fileUrl;
          break;
        case TUIChatEngine.TYPES.MSG_VIDEO:
          url = message.value.payload.remoteVideoUrl;
          break;
        case TUIChatEngine.TYPES.MSG_IMAGE:
          url = message.value.payload.imageInfoArray[0].url;
          break;
      }
      (_window = window) === null || _window === void 0 || _window.open(url, '_blank');
    }
    function revokeMessage() {
      if (!message.value) return;
      // 获取 messageModel
      var messageModel = TUIStore.getMessageModel(message.value.ID);
      messageModel.revokeMessage().then(() => {
        enableSampleTaskStatus('revokeMessage');
      }).catch(error => {
        // 调用异常时业务侧可以通过 promise.catch 捕获异常进行错误处理
        if (error.code === 20016) {
          var _message2 = TUITranslateService.t('TUIChat.已过撤回时限');
          Toast({
            message: _message2,
            type: TOAST_TYPE.ERROR
          });
        }
      });
    }
    function deleteMessage() {
      if (!message.value) return;
      // 获取 messageModel
      var messageModel = TUIStore.getMessageModel(message.value.ID);
      messageModel.deleteMessage();
    }
    function copyMessage() {
      return _copyMessage.apply(this, arguments);
    }
    function _copyMessage() {
      _copyMessage = _asyncToGenerator(function* () {
        var _message$value3;
        var text = decodeTextMessage((_message$value3 = message.value) === null || _message$value3 === void 0 || (_message$value3 = _message$value3.payload) === null || _message$value3 === void 0 ? void 0 : _message$value3.text);
        if (isUniFrameWork) {
          TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.setClipboardData({
            data: text
          });
        } else {
          copyText(text);
        }
      });
      return _copyMessage.apply(this, arguments);
    }
    function forwardSingleMessage() {
      if (!message.value) return;
      TUIStore.update(StoreName.CUSTOM, 'singleForwardMessageID', message.value.ID);
    }
    function quoteMessage() {
      if (!message.value) return;
      message.value.quoteMessage();
    }
    function translateMessage() {
      var enable = TUIStore.getData(StoreName.APP, 'enabledTranslationPlugin');
      if (!enable) {
        Toast({
          message: TUITranslateService.t('TUIChat.请开通翻译功能'),
          type: TOAST_TYPE.WARNING
        });
        return;
      }
      if (!message.value) return;
      var index = actionItems.value.findIndex(item => item.key === 'translate');
      TUIStore.update(StoreName.CHAT, 'translateTextInfo', {
        conversationID: message.value.conversationID,
        messageID: message.value.ID,
        visible: !actionItems.value[index].visible
      });
    }
    function convertVoiceToText() {
      var enable = TUIStore.getData(StoreName.APP, 'enabledVoiceToText');
      if (!enable) {
        Toast({
          message: TUITranslateService.t('TUIChat.请开通语音转文字功能')
        });
        return;
      }
      if (!message.value) return;
      var index = actionItems.value.findIndex(item => item.key === 'convert');
      TUIStore.update(StoreName.CHAT, 'voiceToTextInfo', {
        conversationID: message.value.conversationID,
        messageID: message.value.ID,
        visible: !actionItems.value[index].visible
      });
    }
    function onMessageTranslationInfoUpdated(info) {
      if (info === undefined) return;
      var translationInfoList = info.get(props.messageItem.conversationID) || [];
      var idx = actionItems.value.findIndex(item => item.key === 'translate');
      for (var i = 0; i < translationInfoList.length; ++i) {
        var {
          messageID,
          visible
        } = translationInfoList[i];
        if (messageID === props.messageItem.ID) {
          actionItems.value[idx].text = TUITranslateService.t(visible ? 'TUIChat.隐藏' : 'TUIChat.翻译');
          actionItems.value[idx].visible = !!visible;
          return;
        }
      }
      actionItems.value[idx].text = TUITranslateService.t('TUIChat.翻译');
    }
    function onMessageConvertInfoUpdated(info) {
      if (info === undefined) return;
      var convertInfoList = info.get(props.messageItem.conversationID) || [];
      var idx = actionItems.value.findIndex(item => item.key === 'convert');
      for (var i = 0; i < convertInfoList.length; ++i) {
        var {
          messageID,
          visible
        } = convertInfoList[i];
        if (messageID === props.messageItem.ID) {
          actionItems.value[idx].text = TUITranslateService.t(visible ? 'TUIChat.隐藏' : 'TUIChat.转文字');
          actionItems.value[idx].visible = !!visible;
          return;
        }
      }
      actionItems.value[idx].text = TUITranslateService.t('TUIChat.转文字');
    }
    __expose({
      messageToolDom
    });
    return (_ctx, _cache) => {
      return !_unref(isAllActionItemInvalid) && !_ctx.messageItem.hasRiskContent ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "messageToolDom",
        ref: messageToolDom,
        class: _normalizeClass(['dialog-item', !_unref(isPC) ? 'dialog-item-h5' : 'dialog-item-web'])
      }, [_renderSlot(_ctx.$slots, "TUIEmojiPlugin"), _createElementVNode("div", {
        class: _normalizeClass(["dialog-item-list", !_unref(isPC) ? 'dialog-item-list-h5' : 'dialog-item-list-web'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(actionItems), (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [item.renderCondition() ? (_openBlock(), _createElementBlock("div", {
          key: item.key,
          class: "list-item",
          onClick: $event => getFunction(index)
        }, [_createVNode(Icon, {
          file: item.iconUrl,
          width: "15px",
          height: "15px"
        }, null, 8, ["file"]), _createElementVNode("span", _hoisted_2, _toDisplayString(item.text), 1)], 8, _hoisted_1)) : _createCommentVNode("", true)], 64);
      }), 256))], 2)], 2)) : _createCommentVNode("", true);
    };
  }
});